import { createFileRoute, linkOptions, Outlet, useNavigate } from '@tanstack/react-router';

import { SideMenuLayout } from '@/components/SideMenuLayout';
import { SideMenuNavigation } from '@/components/navigations/SideMenuNavigation';
import { useAppAbility } from '@/hooks/useAppAbility';
import { Action, Subject } from '@/modules/api';

function RouteComponent() {
  const { ability } = useAppAbility();
  const navigate = useNavigate();

  const options = [
    linkOptions({
      to: '/administration/verwaltungsebenen',
      label: 'Verwaltungsebenen',
    }),
    linkOptions({
      to: '/administration/organisationen',
      label: 'Organisationen',
    }),
    linkOptions({
      to: '/administration/benutzerinnen',
      label: 'Benutzer*innen',
    }),
    linkOptions({ to: '/administration/pruefroutinen', label: 'Prüfroutinen' }),
  ];

  if (
    ability?.can(Action.MANAGE, Subject.AdminLevel) ||
    ability?.can(Action.MANAGE, Subject.Organization) ||
    ability?.can(Action.MANAGE, Subject.User)
  )
    return (
      <SideMenuLayout title="Administration" sideMenu={<SideMenuNavigation options={options} />}>
        <Outlet />
      </SideMenuLayout>
    );

  navigate({ to: '/' });
}

export const Route = createFileRoute('/_authenticated/_management/administration')({
  component: RouteComponent,
});
